import { z } from 'zod'

const configSchema = z.object({
  API_URL: z.string(),
  ORIGIN_URL: z.string(),
  NODE_ENV: z.string(),
  FILE_API: z.string(),
  FILE_URL: z.string(),
  ZALO_CALLBACK: z.string(),
  GOOGLE_CALLBACK: z.string(),
  FACEBOOK_CALLBACK: z.string(),
  CLIENT_KEY: z.string(),
  SESSION_AGE: z.number(),
  SITE_NAME: z.string(),
  RECAPCHA_SITE_KEY: z.string(),
  RECAPCHA_SECRET_KEY: z.string(),
  GOOGLE_ANALYTICS: z.string(),
  VAPID_PUBLIC_KEY: z.string(),
  ROUTER_HANDLER_TOKEN: z.string(),
  SECRET_KEY: z.string(),
  REVALIDATE_SECRET: z.string().optional(),
  MAUMAU_FILE_URL: z.string(),
})

const configProject = configSchema.safeParse({
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  ORIGIN_URL: process.env.NEXT_PUBLIC_ORIGIN_URL,
  NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
  FILE_API: process.env.NEXT_PUBLIC_FILE_API,
  FILE_URL: process.env.NEXT_PUBLIC_FILE_URL,
  ZALO_CALLBACK: process.env.NEXT_PUBLIC_NEXTAUTH_ZALO_CALLBACK,
  GOOGLE_CALLBACK: process.env.NEXT_PUBLIC_NEXTAUTH_GOOGLE_CALLBACK,
  FACEBOOK_CALLBACK: process.env.NEXT_PUBLIC_NEXTAUTH_FACEBOOK_CALLBACK,
  CLIENT_KEY: process.env.NEXT_PUBLIC_CLIENT_KEY,
  SESSION_AGE: process.env.NEXT_PUBLIC_SESSION_AGE ? +process.env.NEXT_PUBLIC_SESSION_AGE : 7200000, // 2h
  SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
  RECAPCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPCHA_SITE_KEY,
  RECAPCHA_SECRET_KEY: process.env.NEXT_PUBLIC_RECAPCHA_SECRET_KEY,
  GOOGLE_ANALYTICS: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS,
  VAPID_PUBLIC_KEY: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
  ROUTER_HANDLER_TOKEN: process.env.NEXT_PUBLIC_ROUTE_HANDLER_TOKEN,
  SECRET_KEY: process.env.NEXT_PUBLIC_SECRET_KEY,
  MAUMAU_FILE_URL: process.env.NEXT_PUBLIC_MAUMAU_FILE_URL,
  REVALIDATE_SECRET: process.env.NEXT_PUBLIC_REVALIDATE_SECRET,
})

if (!configProject.success) {
  console.error(configProject.error.errors)
  throw new Error('Invalid config')
}

const envConfig = configProject.data

export default envConfig
